import { styled } from '@mui/material/styles';
import Slider, { SliderProps } from '@mui/material/Slider';
import { Box } from '@mui/material';
import './converge-color-slider.scss';

interface IColorSliderProps extends SliderProps {
  height?: number;
  opacity?: number;
  gradient?: string;
}

const ColorSlider = styled(Slider)<IColorSliderProps>(
  ({ height = 15, opacity = 1, gradient = false }) => ({
    height: height,
    '& .MuiSlider-track': {
      border: '1px solid lightgrey',
    },
    '& .MuiSlider-rail': {
      background:
        gradient === 'blue'
          ? `linear-gradient(to right,
        #f3f4f7 0%, #f3f4f7 10%,
        #e2e3eb 10%, #e2e3eb 20%,
        #c7cdd9 20%, #c7cdd9 30%,
        #b0b8c9 30%, #b0b8c9 40%,
        #9ea7bc 40%, #9ea7bc 50%,
        #8792ad 50%, #8792ad 60%,
        #72809e 60%, #72809e 70%,
        #5b6b8f 70%, #5b6b8f 80%,
        #465780 80%, #465780 90%,
        #2e4371 90%, #2e4371 100%
      )`
          : `linear-gradient(to right,
        #a30100 0%, #a30100 10%,
        #bd0000 10%, #bd0000 20%,
        #d70c00 20%, #d70c00 30%,
        #e34d00 30%, #e34d00 40%,
        #fd9301 40%, #fd9301 50%,
        #efc300 50%, #efc300 60%,
        #afb701 60%, #afb701 70%,
        #77a900 70%, #77a900 80%,
        #3fa300 80%, #3fa300 90%,
        #04a118 90%, #04a118 100%
      )`,
      opacity: opacity,
      '& .MuiSlider-mark': {
        display: 'none',
        color: 'white',
      },
    },
    '& .MuiSlider-thumb': {
      height: height,
      width: 2,
      borderRadius: 0,
      color: 'black',
    },
  })
);

interface IConvergeColorSliderProps {
  height?: number;
  opacity?: number;
  value?: number;
  min: number;
  max: number;
  gradient?: string;
}

export function displayNumber(value?: number) {
  if (value === undefined) {
    return value;
  }
  // Check if the number has a decimal part
  if (value % 1 !== 0) {
    return value.toFixed(2); // Display with one decimal place if it has a decimal part
  } else {
    return value.toFixed(0); // Display without decimal places if it's a whole number
  }
}

export const ConvergeColorSlider = ({
  height,
  opacity,
  value,
  min,
  max,
  gradient,
}: IConvergeColorSliderProps) => {
  return (
    <Box sx={{ width: 350 }} className="color-slider">
      <div className="container">
        <span className="value-pre-text">{min}</span>
        <ColorSlider
          height={height}
          opacity={opacity}
          defaultValue={value}
          valueLabelFormat={value === 0 ? '0' : displayNumber(value)}
          gradient={gradient}
          aria-labelledby="converge-color-slider"
          valueLabelDisplay="on"
          step={10}
          marks
          min={min}
          max={max}
          disabled
        />
        <span className="value-post-text"> {max}</span>
      </div>
    </Box>
  );
};
